<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form :model="table.where" label-width="77px" class="ele-form-search"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-col :md="6" :sm="12">
                        <div class="ele-form-actions">
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->
            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="showEditAdd" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoods:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoods:dall')">批量删除
                </el-button>
            </div>
            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />

                    <el-table-column prop="goods_name" label="商品名称"  show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="goods_store_id" label="商家编号"  show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="goods_code" label="商品编号"  show-overflow-tooltip
                        min-width="120" />


                    <el-table-column prop="goods_price" label="商品售价"  show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="goods_cost_price" label="商品成本价"  show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="goods_integral" label="赠送积分"  show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="goods_number" label="商品库存"  show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip min-width="180">
                     <template slot-scope="scope">
                          <el-button type="primary" @click="upMove(scope.$index,scope.row)">上移</el-button>
                          <el-button type="primary" @click="downMove(scope.$index,scope.row)">下移</el-button>
                      </template>
                     </el-table-column> 

                    <el-table-column prop="status" label="商品状态"  :resizable="false" min-width="120">
                        <template slot-scope="{row}">
                            <div v-if="row.status == 1">正常</div>
                            <div v-if="row.status == 2">下架</div>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="num" label="销量"  show-overflow-tooltip min-width="120" />
                    
                    <el-table-column label="添加时间"  show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="200px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoods:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此商品列吗？" @confirm="remove(row)"  class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:storegoods:delete')">删除</el-link>
                            </el-popconfirm>
                            
                            <el-popconfirm v-if="row.status == 1" title="确定要下架此商品列吗？"  @confirm="status(row)" class="ele-action">
                                <el-link slot="reference"  type="primary" :underline="false"
                                    v-if="permission.includes('sys:storegoods:delete')">下架</el-link>
                            </el-popconfirm>
                            <el-popconfirm v-if="row.status == 2"  title="确定要上架此商品列吗？"  @confirm="status(row)" class="ele-action">
                                <el-link slot="reference" type="primary" :underline="false"
                                    v-if="permission.includes('sys:storegoods:delete')">上架</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改商品列':'添加商品列'" :visible.sync="showEdit" width="800px" @closed="editForm={}"
            :destroy-on-close="true" :lock-scroll="false">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="130px">
                <div v-show="step_status == 1">
                    <el-form-item label="商品分类：" prop="goods_category_id">
                        <el-select v-model="editForm.goods_category_id" multiple @change="selectGoodsType" placeholder="请选择商品类型">
                            <el-option
                              v-for="item in category_info"
                              :key="item.value"
                              :label="item.title"
                              :value="item.id">
                            </el-option>
                          </el-select>
                    </el-form-item>

                    <el-form-item label="商品名称：" prop="goods_name">
                        <el-input v-model="editForm.goods_name" placeholder="请输入商品名称" clearable />
                    </el-form-item>

                    <el-form-item label="商家编号：" prop="goods_store_id">
                        
                        <el-select v-model="editForm.goods_store_id" placeholder="请选择商家编号">
                            <el-option
                              v-for="item in store_info"
                              :key="item.value"
                              :label="item.store_name"
                              :value="item.number">
                            </el-option>
                          </el-select>
                    </el-form-item>

                    <el-form-item label="运费模板：" prop="fare_id">
                       <el-select v-model="editForm.fare_id" multiple placeholder="请选择运费模板">
                           <el-option
                             v-for="item in fare_info"
                             :key="item.value"
                             :label="item.title"
                             :value="item.id">
                           </el-option>
                         </el-select>
                    </el-form-item>
                    
                    <el-form-item label="运费险：" prop="fare_safe">
                        <el-select v-model="editForm.fare_safe" placeholder="请选择运费险">
                            <el-option
                              v-for="item in safe_info"
                              :key="item.value"
                              :label="item.title"
                              :value="item.id">
                            </el-option>
                          </el-select>
                    </el-form-item>


                    <el-form-item label="商品售价：" prop="goods_price">
                        <el-input v-model="editForm.goods_price" controls-position="right" :min="0"
                            placeholder="请输入商品售价" class="ele-fluid ele-text-left" @input="priceFormat(2)" @blur="priceSave" />
                    </el-form-item>

                    <el-form-item label="商品库存：" prop="goods_number">
                        <el-input v-model="editForm.goods_number" type="number" controls-position="right" :min="0"
                            placeholder="请输入商品库存" class="ele-fluid ele-text-left" />
                    </el-form-item>

                    <el-form-item label="商品成本价：" prop="goods_cost_price">
                        <el-input v-model="editForm.goods_cost_price" controls-position="right" :min="0.01"
                            placeholder="请输入商品成本价" class="ele-fluid ele-text-left"  @input="priceFormats(2)" />
                    </el-form-item>

                    <el-form-item label="红包发放额：" prop="red_price">
                        <el-input v-model="editForm.red_price" controls-position="right" :min="0"
                            placeholder="请输入红包发放额" class="ele-fluid ele-text-left" />
                    </el-form-item>

                    <el-form-item label="红包发放天数：" prop="red_day">
                        <el-input v-model="editForm.red_day" type="number"  controls-position="right" :min="0"
                            placeholder="请输入红包发放天数" class="ele-fluid ele-text-left" />
                    </el-form-item>

                    <el-form-item label="计量单位：" prop="goods_unit">
                        <el-input v-model="editForm.goods_unit" placeholder="请输入计量单位" clearable />
                    </el-form-item>

                    <el-form-item label="商品重量：" prop="goods_weight">
                        <el-input v-model="editForm.goods_weight"  type="number" :min="0" placeholder="请输入商品重量" clearable />
                    </el-form-item>

                    <el-form-item label="赠送积分：" prop="goods_integral">
                        <el-input v-model="editForm.goods_integral" type="number"  controls-position="right" :min="0"
                            placeholder="请输入赠送积分" class="ele-fluid ele-text-left" />
                    </el-form-item>
                    <el-form-item label="搜索关键词：" prop="goods_search">
                        <el-input v-model="editForm.goods_search" placeholder="请输入搜索关键词" clearable />
                    </el-form-item>
                    <el-form-item label="商品状态：" prop="status">
                        <el-switch v-model="editForm.status" active-text="上架" inactive-text="下架">
                        </el-switch>
                    </el-form-item>
                </div>
                <div v-show="step_status==2">
                    <el-form-item label="商品规格：" style="display: block;">
                        <div class="ikz-sku">
                            <el-col :span="2">
                                规格：
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox-group class="ikz-checkbox-box" v-model="checked_sku_info"
                                    @change="handleCheckedCitiesChange">
                                    <div v-for="(city,index) in sku_info" :key="city">
                                        <el-checkbox :label="city">{{city}}</el-checkbox>
                                        <el-button @click="delSku(index)" style="margin:0 10px;" type="text">删除</el-button>
                                    </div>
                                </el-checkbox-group>
                            </el-col>
                            <el-col :span="8" style="display: flex;align-items: center;">
                                <el-input v-model="sku_value" placeholder="请输入内容"></el-input>
                                <el-button @click="addSku">增加</el-button>
                            </el-col>
                        </div>
                        <div class="ikz-sku">
                            <el-col :span="2">
                                颜色：
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox-group class="ikz-checkbox-box" v-model="checked_color_info"
                                    @change="handleCheckedCitiesChange">
                                    <div v-for="(city,index) in color_info" :key="city">
                                        <el-checkbox :label="city">{{city}}</el-checkbox>
                                        <el-button @click="delColor(index)" style="margin:0 10px;" type="text">删除</el-button>
                                    </div>
                                </el-checkbox-group>
                            </el-col>
                            <el-col :span="8" style="display: flex;align-items: center;">
                                <el-input  v-model="color_value" placeholder="请输入内容"></el-input>
                                <el-button @click="addColor">增加</el-button>
                            </el-col>
                        </div>
                    </el-form-item>
                    <el-table :data="tableData" border style="width: 631px;">
                        <el-table-column prop="sku" label="规格" width="150">
                        </el-table-column>
                        <el-table-column prop="color" label="颜色" width="120">
                        </el-table-column>
                        <el-table-column prop="sku_price" label="销售价格" width="120">
                             <template slot-scope="{row}"><el-input type="number" v-model="row.sku_price" placeholder="输入价格"></el-input></template>
                        </el-table-column>
                        <el-table-column prop="sku_stock" label="商品库存" width="120">
                             <template slot-scope="{row}"><el-input type="number" v-model="row.sku_stock" placeholder="输入库存"></el-input></template>
                        </el-table-column>
                        <el-table-column prop="image" label="商品图片" width="120">
                            <template slot-scope="{row}"><uploadImage :limit="1" v-model="row.image"></uploadImage></template>
                        </el-table-column>
                    </el-table>
                    <el-form-item label="商品图片：" prop="goods_img">
                        <uploadGoodsImage :limit="5" v-model="image" @returnIndex="goodsImgIndex"></uploadGoodsImage>
                    </el-form-item>
                    <el-form-item label="商品描述：" prop="goods_desc">
                        <tinymce-editor v-model="editForm.goods_desc" :init="initEditor"/>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer">
                <el-button type="primary" v-if="step_status == 1" @click="stepSet">下一步，填写商品属性</el-button>
                <!-- <el-button @click="showEdit=false">取消</el-button> -->
                <el-button type="primary" v-if="step_status == 2" @click="stepSetUp">上一步</el-button>
                <el-button type="primary" v-if="step_status == 2" @click="save">上传完成</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import TinymceEditor from '@/components/TinymceEditor'
    import uploadImage from '@/components/uploadImage'
    import uploadGoodsImage from '@/components/uploadGoodsImage'
    import {
        mapGetters
    } from "vuex";
    export default {
        name: "SysStoreGoods",
        data() {
            return {
                desc:'',
                image:[],
                category_info:'',
                goods_img_index:'0',
                tableData: [],
                sku_info:[],//规格数据
                color_info:[],//颜色数据
                checked_sku_info: [],
                checked_color_info: [],
                editForm: {
                    goods_desc:''
                }, // 表单数据
                sku_value:'',//规格输入
                color_value:'',//颜色输入输入
                step_status: '1', //步骤
                table: {
                    url: '/storegoods/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editRules: { // 表单验证规则

                    goods_name: [{
                        required: true,
                        message: '请输入商品名称',
                        trigger: 'blur'
                    }],

                    goods_store_id: [{
                        required: true,
                        message: '请输入商家编号',
                        trigger: 'blur'
                    }],

                    goods_code: [{
                        required: true,
                        message: '请输入商品编号',
                        trigger: 'blur'
                    }],

                    goods_desc: [{
                        required: true,
                        message: '请输入商品描述',
                        trigger: 'blur'
                    }],

                    goods_card: [{
                        required: true,
                        message: '请输入商品标签',
                        trigger: 'blur'
                    }],

                    goods_price: [{
                        required: true,
                        message: '请输入商品售价',
                        trigger: 'blur'
                    }],

                    goods_cost_price: [{
                        required: true,
                        message: '请输入商品成本价',
                        trigger: 'blur'
                    }],

                    red_price: [{
                        required: true,
                        message: '请输入红包发放额',
                        trigger: 'blur'
                    }],

                    red_day: [{
                        required: true,
                        message: '请输入红包发放天数',
                        trigger: 'blur'
                    }],

                    goods_weight: [{
                        required: true,
                        message: '请输入商品重量',
                        trigger: 'blur'
                    }],

                    goods_integral: [{
                        required: true,
                        message: '请输入赠送积分',
                        trigger: 'blur'
                    }],

                    goods_number: [{
                        required: true,
                        message: '请输入商品库存',
                        trigger: 'blur'
                    }],

                    goods_unit: [{
                        required: true,
                        message: '请输入计量单位',
                        trigger: 'blur'
                    }],

                    goods_img: [{
                        required: true,
                        message: '请输入商品图片',
                        trigger: 'blur'
                    }],

                    goods_category_id: [{
                        required: true,
                        message: '请输入关联的栏目id',
                        trigger: 'blur'
                    }],

                    goods_search: [{
                        required: true,
                        message: '请输入搜索关键词',
                        trigger: 'blur'
                    }],

                    num: [{
                        required: true,
                        message: '请输入销量',
                        trigger: 'blur'
                    }],

                    fare_id: [{
                        required: true,
                        message: '请输入运费模板',
                        trigger: 'blur'
                    }],

                    goods_intro: [{
                        required: true,
                        message: '请输入商品信息简介',
                        trigger: 'blur'
                    }],

                },
                fare_info:[],
                store_info:[],
                safe_info:[],
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            initEditor() {
              return {
                height: 400,
                file_picker_callback: this.file_picker_callback,
                skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' : '/tinymce/skins/ui/oxide',
                content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
                images_upload_handler: (blobInfo, success, error) => {
                  let file = blobInfo.blob();
                  // 使用axios上传
                  const formData = new FormData();
                  formData.append('file', file, file.name);
                  this.$http.post('/upload/uploadImage', formData).then(res => {
                    if (res.data.code == 0) {
                      success(res.data.data);
                    } else {
                      error(res.data.msg);
                    }
                  }).catch(e => {
                    error(e.message);
                  });
                }
              };
            }
        },
        components: {uploadImage,uploadGoodsImage,TinymceEditor},
        mounted() {
            this.category();
            this.fareInfo();
            this.safeInfo();
        },
        methods: {
            //验证价格
            priceBlur(e){
                console.log(e);
            },
            upMove(index,e){
                var temp_data = {
                    sort:e.sort,
                    id:e.id,
                    status:1,
                    
                }
              this.editSort(temp_data);
                this.$refs.table.reload();
                // this.show_data[index] = this.show_data.splice(index + 1, 1, this.show_data[index])[0]
            },
            downMove(index,e){
                var temp_data = {
                    sort:e.sort,
                    id:e.id,
                    status:2,
                }
                this.editSort(temp_data);
            },
            editSort(data){
              this.$http.post('/storegoods/editSort',data).then(res => {
                if (res.data.code === 0) {
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.msg);
                }
              }).catch(e => {
                this.$message.error(e.message);
              });  
            },
            //计算单价 decimal 为小数点后的精度
                priceFormat(decimal){
                  var val = this.editForm.goods_price
                  val = val.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
                  val = val.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
                  val = val
                    .replace('.', '$#$')
                    .replace(/\./g, '')
                    .replace('$#$', '.')
                  switch (decimal) {
                    case 1:
                      val = val.replace(/^(-)*(\d+)\.(\d{1}).*$/, '$1$2.$3')
                      break
                    case 2:
                      val = val.replace(/^(-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')
                      break
                    case 3:
                      val = val.replace(/^(-)*(\d+)\.(\d{3}).*$/, '$1$2.$3')
                      break
                    case 4:
                      val = val.replace(/^(-)*(\d+)\.(\d{4}).*$/, '$1$2.$3')
                      break
                    case 5:
                      val = val.replace(/^(-)*(\d+)\.(\d{5}).*$/, '$1$2.$3')
                      break
                    case 6:
                      val = val.replace(/^(-)*(\d+)\.(\d{6}).*$/, '$1$2.$3')
                      break
                    case 7:
                      val = val.replace(/^(-)*(\d+)\.(\d{7}).*$/, '$1$2.$3')
                      break
                    case 8:
                      val = val.replace(/^(-)*(\d+)\.(\d{8}).*$/, '$1$2.$3')
                      break
                    case 9:
                      val = val.replace(/^(-)*(\d+)\.(\d{9}).*$/, '$1$2.$3')
                      break
                    default:
                      val = val.replace(/^(-)*(\d+)\.().*$/, '$1$2.$3')
                      break
                  }
                  // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                  if (val.indexOf('.') < 0 && val != '') {
                    if (val.length > 9) {
                      val = val.substr(0, 9)
                    }
                    val = parseFloat(val)
                  }else {
                    const arr = val.split('.')
                    if(arr[0].length > 0){
                      arr[0] = parseFloat(arr[0])
                    }else if(arr.length == 2 && arr[0] == '') {
                      arr[0] = 0
                    }
                    val = arr.join('.')
                  } 
                    this.editForm.goods_price = val
                },
                //计算单价 decimal 为小数点后的精度
                    priceFormats(decimal){
                      var val = this.editForm.goods_price
                      val = val.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
                      val = val.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
                      val = val
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.')
                      switch (decimal) {
                        case 1:
                          val = val.replace(/^(-)*(\d+)\.(\d{1}).*$/, '$1$2.$3')
                          break
                        case 2:
                          val = val.replace(/^(-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')
                          break
                        case 3:
                          val = val.replace(/^(-)*(\d+)\.(\d{3}).*$/, '$1$2.$3')
                          break
                        case 4:
                          val = val.replace(/^(-)*(\d+)\.(\d{4}).*$/, '$1$2.$3')
                          break
                        case 5:
                          val = val.replace(/^(-)*(\d+)\.(\d{5}).*$/, '$1$2.$3')
                          break
                        case 6:
                          val = val.replace(/^(-)*(\d+)\.(\d{6}).*$/, '$1$2.$3')
                          break
                        case 7:
                          val = val.replace(/^(-)*(\d+)\.(\d{7}).*$/, '$1$2.$3')
                          break
                        case 8:
                          val = val.replace(/^(-)*(\d+)\.(\d{8}).*$/, '$1$2.$3')
                          break
                        case 9:
                          val = val.replace(/^(-)*(\d+)\.(\d{9}).*$/, '$1$2.$3')
                          break
                        default:
                          val = val.replace(/^(-)*(\d+)\.().*$/, '$1$2.$3')
                          break
                      }
                      // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                      if (val.indexOf('.') < 0 && val != '') {
                        if (val.length > 9) {
                          val = val.substr(0, 9)
                        }
                        val = parseFloat(val)
                      }else {
                        const arr = val.split('.')
                        if(arr[0].length > 0){
                          arr[0] = parseFloat(arr[0])
                        }else if(arr.length == 2 && arr[0] == '') {
                          arr[0] = 0
                        }
                        val = arr.join('.')
                      } 
                      this.editForm.goods_price = val
                    },
                priceSave(){
                    if( this.editForm.goods_price == 0|| this.editForm.goods_price > 0){
                        var val = this.editForm.goods_price + ''
                        if (val.indexOf('.') < 0 && val != '') {
                          val = val + '.00'
                        }else {
                          const arr = val.split('.')
                          if(arr.length == 2){
                            if(arr[1] == ''){
                              arr[1] = '00'
                            }else if(arr[1].length == 1){
                              arr[1] = arr[1] + '0'
                            }
                          }
                          val = arr.join('.')
                        }
                        console.log(val);
                        if(val == 0.00){
                            this.editForm.goods_price = ''
                        }else{
                            this.editForm.goods_price = val
                        }
                    }
                  
                },
            /**
              * 选择运费险
              */
            safeInfo(){
                this.$http.get('/storesafe/listInfo').then(res => {
                  if (res.data.code === 0) {
                    this.safe_info = res.data.data;
                  } else {
                    this.$message.error(res.data.msg);
                  }
                }).catch(e => {
                  this.$message.error(e.message);
                });
            },
            /**
              * 选择运费
              */
            fareInfo(){
                this.$http.get('/storegoodsfare/listInfo').then(res => {
                  if (res.data.code === 0) {
                    this.fare_info = res.data.data;
                  } else {
                    this.$message.error(res.data.msg);
                  }
                }).catch(e => {
                  this.$message.error(e.message);
                });
            },
            /**
              * 选择商品分类
              */
            selectGoodsType(){
                this.shopInfo();
                // console.log(this.editForm.goods_category_id);
                
            },
            shopInfo(){
                this.$http.get('/store/listInfo?goods_type='+this.editForm.goods_category_id.join(',')).then(res => {
                  if (res.data.code === 0) {
                    this.store_info = res.data.data;
                  } else {
                    this.$message.error(res.data.msg);
                  }
                }).catch(e => {
                  this.$message.error(e.message);
                });
            },
            /**
              * 查询分类列表
              */
            category(){
                this.$http.get('/storegoodscategory/categoryInfo').then(res => {
                  if (res.data.code === 0) {
                    this.category_info = res.data.data;
                  } else {
                    this.$message.error(res.data.msg);
                  }
                }).catch(e => {
                  this.$message.error(e.message);
                });
            },
            //主图返回
            goodsImgIndex(e){
                this.goods_img_index = e;
            },
            handleCheckedCitiesChange(e) {
                console.log(e);
                this.skuTable();
            },
            showEditAdd() {
                this.showEdit = true;
                this.tableData = [];
                this.sku_info = [];
                this.color_info = [];
                this.checked_sku_info = [];
                this.checked_color_info = [];
                this.editForm = {};
                this.image = [];
                this.step_status = 1;
                setTimeout(() => { 
                     this.editForm.goods_desc = '<h3><span style="font-size: 12pt;"><strong>上传说明：</strong></span></h3><p><span style="color: #7e8c8d; font-size: 8pt;"><strong>1、480px&lt;图片宽度&lt;1500px （手机端宽度建议上传750px）, 0</strong></span><span style="color: #7e8c8d; font-size: 8pt;"><strong>&lt;图片高度建议2500px 。</strong></span></p><p><span style="color: #7e8c8d; font-size: 8pt;"><strong>2、图片大小&lt; 10M</strong></span></p><p><span style="color: #7e8c8d; font-size: 8pt;"><strong>对于图片宽高可参考：</strong></span></p><p><span style="font-size: 8pt;"><img src="https://image.ysext.com/admin/20221008222554.JPG" width="215" height="281" /></span></p><p><span style="color: #7e8c8d; font-size: 8pt;"><strong>温馨提示: 若你上传的图片宽高度超出了限制，系统会自动等比例调整至要求内，有可能会出现图片高宽度导致变形等问题，建议你最好上传时按照尺寸调整好后在进行上传。未超过系统限制则不会修改</strong><strong>。</strong></span></p><p>&nbsp;</p> <p>&nbsp;</p><p>&nbsp;</p>';
                 }, 100);
            },
            skuTable(){
                
                let tableData = [];
                if(this.checked_sku_info.length || this.checked_color_info.length){
                    if(this.checked_sku_info.length>=this.checked_color_info.length){
                        for(var i =0;i<this.checked_sku_info.length;i++){
                            if(this.checked_color_info.length){
                                for(var j =0;j<this.checked_color_info.length;j++){
                                    var data = {
                                        sku:this.checked_sku_info[i],
                                        color:this.checked_color_info[j],
                                        sku_price:'',
                                        sku_stock:'',
                                        image:''
                                    }
                                    tableData.push(data);
                                }
                            }else{
                                var data1 = {
                                    sku:this.checked_sku_info[i],
                                    color:'',
                                    sku_price:'',
                                    sku_stock:'',
                                    image:''
                                }
                                tableData.push(data1);
                            }
                        }
                    }else{
                        for(var o =0;o<this.checked_color_info.length;o++){
                            if(this.checked_color_info.length){
                                for(var m =0;m<this.checked_sku_info.length;m++){
                                    var data2 = {
                                        sku:this.checked_sku_info[m],
                                        color:this.checked_color_info[o],
                                        sku_price:'',
                                        sku_stock:'',
                                        image:''
                                    }
                                    tableData.push(data2);
                                }
                            }else{
                                var data3 = {
                                    sku:'',
                                    color:this.checked_color_info[o],
                                    sku_price:'',
                                    sku_stock:'',
                                    image:''
                                }
                                tableData.push(data3);
                            }
                        }
                    }
                }else{
                    tableData = [];
                }
                if(this.tableData.length && tableData.length){
                    for(var t = 0;t<tableData.length;t++){
                        for(var td = 0;td<this.tableData.length;td++){
                            if(tableData[t].sku == this.tableData[td].sku && tableData[t].color == this.tableData[td].color){
                                tableData[t].sku_price = this.tableData[td].sku_price;
                                tableData[t].sku_stock = this.tableData[td].sku_stock;
                                tableData[t].image = this.tableData[td].image;
                            }
                        }
                    }
                }
                this.tableData = JSON.parse(JSON.stringify(tableData));
            },
            /**
              * 添加规格
              */
            addSku(){
                if(this.sku_value){
                    this.sku_info.push(this.sku_value);
                    this.sku_value = '';
                }
            },
            /**
              * 添加颜色
              */
            addColor(){
                if(this.color_value){
                    this.color_info.push(this.color_value);
                    this.color_value = '';
                }
            },
            /**
              * 删除规格
              */
            delSku(index){
                for(var i = 0;i<this.checked_sku_info.length;i++){
                    if(this.sku_info[index] ==this.checked_sku_info[i] ){
                        this.checked_sku_info.splice(i,1);
                        this.skuTable();
                        break;
                    }
                }
                this.sku_info.splice(index,1);
            },
            /**
              * 删除颜色
              */
            delColor(index){
                for(var i = 0;i<this.checked_color_info.length;i++){
                    if(this.color_info[index] ==this.checked_color_info[i] ){
                        this.checked_color_info.splice(i,1);
                        this.skuTable();
                        break;
                    }
                }
                this.color_info.splice(index,1);
            },
            
            /**
             * 下一步
             */
            stepSet() {
                this.step_status = 2;
            },
            /**
             * 上一步
             */
            stepSetUp() {
                this.step_status = 1;
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.tableData = [];
                this.sku_info = [];
                this.color_info = [];
                this.checked_sku_info = [];
                this.checked_color_info = [];
                this.editForm = {};
                this.image = [];
                this.showEdit = true;
                this.$http.get('/storegoods/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.editForm = res.data.data;
                        this.editForm.status = this.editForm.status == 1?true:false;
                        this.step_status = 1;
                        this.image = this.editForm.goods_img;
                        
                        if(this.editForm.tableData){
                            this.tableData = this.editForm.tableData;
                        }
                        if(this.editForm.sku_info){
                            if(this.editForm.color_info){
                                this.color_info = this.editForm.color_info.split(',');
                            }
                            if(this.editForm.sku_info){
                                this.sku_info = this.editForm.sku_info.split(',');
                            }
                            if(this.editForm.checked_sku_info){
                                this.checked_sku_info = this.editForm.checked_sku_info.split(',');
                            }
                            if(this.editForm.checked_color_info){
                                this.checked_color_info = this.editForm.checked_color_info.split(',');
                            }
                        }
                        var temp_goods_category_id = this.editForm.goods_category_id.toString().split(',');
                        for(var j = 0;j<temp_goods_category_id.length;j++){
                            temp_goods_category_id[j] = parseInt(temp_goods_category_id[j])
                        }
                        this.editForm.goods_category_id = temp_goods_category_id;
                        var temp_fare_id = this.editForm.fare_id.split(',');
                        for(var i = 0;i<temp_fare_id.length;i++){
                            temp_fare_id[i] = parseInt(temp_fare_id[i])
                        }
                        this.editForm.fare_id = temp_fare_id;
                        this.shopInfo();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                if(this.tableData.length>0){
                    for(var i = 0;i<this.tableData.length;i++){
                        if(!this.tableData[i].sku_price|| this.tableData[i].sku_price == 0||this.tableData[i].sku_price == 0.00){
                            this.$message({
                                type: 'error',
                                message: '请输入商品价格'
                            });
                            return false;
                        }
                        if(!this.tableData[i].sku_stock|| this.tableData[i].sku_stock == 0||this.tableData[i].sku_stock == 0.00){
                            this.$message({
                                type: 'error',
                                message: '请输入商品规格'
                            });
                            return false;
                        }
                        
                    }
                }
                var form_data = JSON.parse(JSON.stringify(this.editForm));
                this.editForm.goods_img = this.image;
                form_data.checked_sku_info = this.checked_sku_info.join(',');
                form_data.checked_color_info = this.checked_color_info.join(',');
                form_data.sku_info = this.sku_info.join(',');
                form_data.color_info = this.color_info.join(',');
                form_data.tableData = JSON.stringify(this.tableData);
                form_data.goods_img = this.image.join(",");
                form_data.fare_id = JSON.parse(JSON.stringify(form_data.fare_id)).join(',');
                form_data.goods_category_id = JSON.parse(JSON.stringify(form_data.goods_category_id)).join(',');
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/storegoods/edit', form_data).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.tableData = [];
                                this.sku_info = [];
                                this.color_info = [];
                                this.checked_sku_info = [];
                                this.checked_color_info = [];
                                this.editForm = {};
                                this.image = [];
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的商品列吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/storegoods/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/storegoods/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /**
             * 更改商品状态
             */
            status(row) {
                const loading = this.$loading({
                    lock: true
                });
                row.status = row.status == 1?2:1;
                let params = Object.assign({}, row);
                this.$http.post("/storegoods/status", params).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row.status = !row.status ? 2 : 1;
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }

    .ikz-checkbox-box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .ikz-sku {
        display: flex;
        align-items: center;
    }

    .ikz-sku-title {
        width: 60px;
    }
</style>
